import * as React from "react";
import { cn } from "../../lib/cn";

export type BadgeVariant = "green" | "red" | "blue" | "amber" | "purple" | "gray";

const variantClasses: Record<BadgeVariant, string> = {
  green:  "bg-emerald-50 text-emerald-700 border-emerald-200",
  red:    "bg-red-50    text-red-600    border-red-200",
  blue:   "bg-blue-50   text-blue-700   border-blue-200",
  amber:  "bg-amber-50  text-amber-700  border-amber-200",
  purple: "bg-purple-50 text-purple-700 border-purple-200",
  gray:   "bg-gray-100  text-gray-600   border-gray-200",
};

export interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = "gray", children, className }: BadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border",
      variantClasses[variant],
      className,
    )}>
      {children}
    </span>
  );
}
